// Operations that start with these prefixes are sent without the auth token,
// because the client calls them before it has one. The exceptions are called
// by a signed-in client and need the token.
const PREFIXES_WITHOUT_AUTH_TOKEN = ["auth", "device"];
const EXCEPTIONS_WITH_AUTH_TOKEN = [
    "authSelectUserRole",
    "authUpdateLogin",
    "deviceByPinCode",
    "deviceConfig",
];

// The password reset page works without signing in. A token left over from an
// earlier session would only get the request rejected if it has expired.
const OPERATIONS_WITHOUT_AUTH_TOKEN = [
    "passwordResetRequest",
    "passwordResetTokenRedeem",
    "passwordResetTokenUpdatePassword",
];

export function sendsAuthToken(operationName: string | undefined): boolean {
    if (!operationName || EXCEPTIONS_WITH_AUTH_TOKEN.includes(operationName)) {
        return true;
    }

    if (OPERATIONS_WITHOUT_AUTH_TOKEN.includes(operationName)) {
        return false;
    }

    return !PREFIXES_WITHOUT_AUTH_TOKEN.some(prefix =>
        operationName.startsWith(prefix)
    );
}
